import { ROLE_PROMO_ADMIN_USER } from '~/consts/roles';

import useCurrentUser from '~/hooks/useCurrentUser';

const usePromoAdminPermission = () => {
  const { user } = useCurrentUser();

  return user?.roles.includes(ROLE_PROMO_ADMIN_USER);
};

export default usePromoAdminPermission;
